const DEFAULT_STEP_CARDS = [
  { step: 1, title: 'Information requirement checklist', instructions: '', statusMessage: 'Upload Documents' },
  { step: 2, title: 'Pending Queries', instructions: '', statusMessage: 'Resolve Queries' },
  { step: 3, title: 'Draft financials', instructions: '', statusMessage: 'Review Draft' },
  { step: 4, title: 'Final Books', instructions: '', statusMessage: 'View Final Books' },
];

const DEFAULT_CHECKLIST = [
  {
    key: 'Bank Statements',
    title: 'Uploads Documents',
    description: 'Please upload the Bank/Credit Card statements and other supporting documents for the particular period.',
    isActive: true,
  },
];

export const getBookkeepingPageMeta = (content) => {
  const stepCards = (content?.stepCards?.length ? content.stepCards : DEFAULT_STEP_CARDS).map((card, index) => ({
    ...DEFAULT_STEP_CARDS[index],
    ...card,
  }));

  const checklistCategories = (content?.checklistCategories?.length ? content.checklistCategories : DEFAULT_CHECKLIST)
    .filter((cat) => cat.isActive !== false);

  return {
    pageTitle: content?.pageTitle || 'Bookkeeping',
    pageSubtitle: content?.pageSubtitle || 'Upload documents, resolve queries, and track your bookkeeping progress',
    loadingMessage: content?.loadingMessage || 'Loading your financial data...',
    bundleBannerText: content?.bundleBannerText || '1099 Form is Activated - 4 Nos',
    scheduleBannerTitle: content?.scheduleBannerTitle || 'Active Bookkeeping Schedule',
    scheduleFrequencyPrefix: content?.scheduleFrequencyPrefix || 'Your bookkeeping frequency is',
    scheduleStartedPrefix: content?.scheduleStartedPrefix || 'started on',
    scheduleDueDateLabel: content?.scheduleDueDateLabel || 'Next Filing Due Date',
    financialRecordsTitle: content?.financialRecordsTitle || 'Financial Records',
    financialRecordsEmpty: content?.financialRecordsEmpty || 'No additional data available',
    errorRetryLabel: content?.errorRetryLabel || 'Try Again',
    errorRefreshingLabel: content?.errorRefreshingLabel || 'Refreshing...',
    stepCards,
    checklistCategories,
    step1Modal: { ...(content?.step1Modal || {}) },
    queriesModal: { ...(content?.queriesModal || {}) },
    step3Modal: { ...(content?.step3Modal || {}) },
    uploadModal: { ...(content?.uploadModal || {}) },
    toasts: { ...(content?.toasts || {}) },
  };
};

export const mergeBookkeepingSteps = (apiSteps, stepCards) => {
  const cards = stepCards?.length ? stepCards : DEFAULT_STEP_CARDS;
  if (!Array.isArray(apiSteps) || !apiSteps.length) {
    return cards.map((config) => ({
      ...config,
      status: config.step === 1 ? 'in-progress' : 'pending',
    }));
  }

  return cards.map((config) => {
    const matched = apiSteps.find((s) => s.step === config.step);
    return {
      ...config,
      title: config.title || matched?.title,
      status: matched?.status || (config.step === 1 ? 'in-progress' : 'pending'),
    };
  });
};

export const buildCategoryFileState = (categories) => {
  const state = {};
  (categories || DEFAULT_CHECKLIST).forEach((cat) => {
    if (cat.key) state[cat.key] = [];
  });
  return state;
};

export const getModalCopy = (meta, section, key, fallback = '') =>
  meta?.[section]?.[key] || fallback;
